const googlePatentsTheme = {
  dot: "bg-amber-400",
  accentText: "text-amber-200",
  subtleText: "text-amber-300",
  tabActive: "border-amber-400/40 bg-amber-500/10 text-amber-100",
  selectedRow: "border-l-2 border-amber-400 bg-amber-500/[0.08]",
  accentBadge: "border border-amber-400/30 bg-amber-500/10 text-amber-100",
  idBadge: "border border-amber-400/25 bg-amber-500/5 text-amber-100",
  detailBorder: "border-amber-400/25",
  detailGlow: "from-amber-400/25",
  checkbox:
    "border-amber-300/40 text-amber-200 hover:border-amber-200/60 hover:bg-amber-950/70 focus-visible:ring-amber-300/25",
  checkboxChecked:
    "border-amber-100/75 from-amber-300 to-yellow-400 shadow-[0_0_0_1px_rgba(253,230,138,0.18),0_10px_22px_rgba(245,158,11,0.24)]",
};

export default googlePatentsTheme;
